<template>
  <el-dropdown v-if="items.length" @command="handleCommand">
    <button class="btn md__btn-primary">
      Nueva <i class="el-icon-arrow-down el-icon--right"></i>
    </button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in items"
        :key="item.route"
        :command="item.route"
        >{{ item.label }}</el-dropdown-item
      >
      <!-- <el-dropdown-item command="quote">Cobros</el-dropdown-item> -->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "ButtonAddSaleDocumentsComponent",
  computed: {
    // Solo los documentos que el rol puede crear.
    items() {
      return [
        { route: "sales.quotes.add", label: "Cotización" },
        { route: "sales.invoices.add", label: "Factura" },
        { route: "sales.liquidations.add", label: "Liquidación Compra" },
        { route: "sales.creditNote.add", label: "Nota de crédito" },
        { route: "sales.debitNote.add", label: "Nota de debito" },
        { route: "sales.withholdings.add", label: "Retención" },
        { route: "sales.remissions.add", label: "Guía de Remisión" }
      ].filter(item => this.$canOpen(item.route));
    }
  },
  methods: {
    handleCommand(command) {
      this.goRouter(command);
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    }
  }
};
</script>

<style lang="scss" scoped>
.md__btn-primary {
  padding: 0 1rem !important;
}
</style>
